/* External Imports */
import { Box, useBreakpointValue } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/**
 * Renders the SingleImageForArmy Card component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.my
 * @param sectionContent.px
 * @param sectionContent.w
 * @param sectionContent.h
 * @param sectionContent.maxWidth
 * @param sectionContent.mx
 * @returns {ReactElement} SingleImage Card component
 */

const SingleImageForArmy = ({ sectionContent }) => {
  const image = useBreakpointValue({
    base: sectionContent?.mobileImage,
    md: sectionContent?.tabletImage,
    lg: sectionContent?.image,
  });
  return sectionContent ? (
    <Box mx={'auto'}>
      <LazyLoadImageComponent
        h={'auto'}
        alt={image?.alt}
        title={image?.title}
        textAlign="center"
        loading="eager"
        src={image?.url}
        w={'auto'}
        maxWidth={'100%'}
      />
    </Box>
  ) : null;
};

export default SingleImageForArmy;
